export function getRoleDisplayName(role) {
  if (!role) return '';
  if (typeof role === 'string') return role;
  return role.name || '';
}

export function getRolesWithPositionEmail(roles) {
  if (!Array.isArray(roles)) return [];
  return roles.filter(
    (role) => typeof role === 'object' && Boolean(role.positionEmail?.trim())
  );
}
